export enum FromStoreTransferEnum {
  PercentOverModelStock = 1,
  QuantityOverModelStock = 2,
  MinOnly = 3,
  MinPlusWos = 4,
  Smoothing = 5
}

export enum FromStoreTransferRankEnum {
  HighestPercentOverModelStock = 1,
  HighestQuantityOverModelStock = 2,
  LowestRankFirst = 3,
  HighestWeekCoverFirst = 4
}

export enum ToStoreTransferEnum {
  BelowModelStock = 1,
  BelowMin = 2,
  MinPlusWos = 3
}

export enum ToStoreTransferRankEnum {
  HighestPercentUnderModelStock = 1,
  HighestQuantityUnderModelStock = 2,
  HighestRankFirst = 3,
  LowestWeekCoverFirst = 4
}

export enum TransferThresholdTypeEnum {
  MinTransferQuantity = 1,
  MinTransferValue = 2
}

//Label of Enums

export const TransferEnumLabels = {
  FromStoreTransferEnum: {
    [FromStoreTransferEnum.PercentOverModelStock]: 'Percent Over Model Stock',
    [FromStoreTransferEnum.QuantityOverModelStock]: 'Quantity Over Model Stock',
    [FromStoreTransferEnum.MinOnly]: 'Min Only',
    [FromStoreTransferEnum.MinPlusWos]: 'Min Plus WOS',
    [FromStoreTransferEnum.Smoothing]: 'Smoothing'
  },
  FromStoreTransferRankEnum: {
    [FromStoreTransferRankEnum.HighestPercentOverModelStock]: 'Highest Percent Over Model Stock',
    [FromStoreTransferRankEnum.HighestQuantityOverModelStock]: 'Highest Quantity Over Model Stock',
    [FromStoreTransferRankEnum.LowestRankFirst]: 'Lowest Rank First',
    [FromStoreTransferRankEnum.HighestWeekCoverFirst]: 'Highest Week Cover First'
  },
  ToStoreTransferEnum: {
    [ToStoreTransferEnum.BelowModelStock]: 'Below Model Stock',
    [ToStoreTransferEnum.BelowMin]: 'Below Min',
    [ToStoreTransferEnum.MinPlusWos]: 'Min Plus WOS'
  },
  ToStoreTransferRankEnum: {
    [ToStoreTransferRankEnum.HighestPercentUnderModelStock]: 'Highest Percent Under Model Stock',
    [ToStoreTransferRankEnum.HighestQuantityUnderModelStock]: 'Highest Quantity Under Model Stock',
    [ToStoreTransferRankEnum.HighestRankFirst]: 'Highest Rank First',
    [ToStoreTransferRankEnum.LowestWeekCoverFirst]: 'Lowest Week Cover First'
  },
  TransferThresholdTypeEnum: {
    [TransferThresholdTypeEnum.MinTransferQuantity]: 'Min Transfer Quantity',
    [TransferThresholdTypeEnum.MinTransferValue]: 'Min Transfer Value'
  }
};

// Function convert enum into Options 
export function getEnumDropdownOptions<T extends object>(
  enumObj: T,
  labelMap: Record<number, string>
) {
  return Object.values(enumObj)
    .filter(value => typeof value === 'number')
    .map(value => ({
      id: value,
      name: labelMap[value]
    }));
}

export function getStringEnumAsOptions<T extends object>(
  enumObj: T,
  labelMap: Record<number, string>
) {
  return Object.values(enumObj)
    .map(value => ({
      id: value,
      name: labelMap[value]
    }));
}
export enum ZeroMovementStoreTransferEnum {
  ZeroMovementStoreOnly = 1,
  ZeroMovementStoreFirst = 2,
  NotApplied = 3
}

export enum FromStorePriorityEnum {
  AreaManager = 1,
  StateBreakdown = 2,
  State = 3,
  National = 4
}

export const ZeroMovementStoreTransferLabels = {
  [ZeroMovementStoreTransferEnum.ZeroMovementStoreOnly]: "Zero Movement Store Only",
  [ZeroMovementStoreTransferEnum.ZeroMovementStoreFirst]: "Zero Movement Store First",
  [ZeroMovementStoreTransferEnum.NotApplied]: "Not Applied"
};

export const FromStorePriorityLabels = {
  [FromStorePriorityEnum.AreaManager]: "Area Manager",
  [FromStorePriorityEnum.StateBreakdown]: "State Breakdown",
  [FromStorePriorityEnum.State]: "State",
  [FromStorePriorityEnum.National]: "National"
};

export enum StoreTransferJobType {
  Combined_Selection = 1,
  Separate_Selection = 2,
}

export const StoreTransferJobTypeLabel = {
  [StoreTransferJobType.Combined_Selection]: "Combined Selection",
  [StoreTransferJobType.Separate_Selection]: "Separate Selection",
};

export enum StoreTransferExportEnum {

    STORE_TRANSFER_EXCLUDE_SOO = 1,
    STORE_TRANSFER_MIN_WEEKS_CVR = 2,
    STORE_TRANSFER_MODEL = 3,
    STORE_TRANSFER_SMOOTH_STATE_GRP = 4,
    STORE_TRANSFER_SMOOTH_AREA_MNG = 5,
    STORE_TRANSFER_ZM_ONLY = 6
}

export const StoreTransferExportEnumLabel = {
  [StoreTransferExportEnum.STORE_TRANSFER_EXCLUDE_SOO]: "STORE TRANSFER EXCLUDE SOO",
  [StoreTransferExportEnum.STORE_TRANSFER_MIN_WEEKS_CVR]: "STORE TRANSFER MIN WEEKS CVR",
  [StoreTransferExportEnum.STORE_TRANSFER_MODEL]: "STORE TRANSFER MODEL",
  [StoreTransferExportEnum.STORE_TRANSFER_SMOOTH_STATE_GRP]: "STORE TRANSFER SMOOTH STATE GRP",
  [StoreTransferExportEnum.STORE_TRANSFER_SMOOTH_AREA_MNG]: "STORE TRANSFER SMOOTH AREA MNG",
  [StoreTransferExportEnum.STORE_TRANSFER_ZM_ONLY]: "STORE TRANSFER ZM ONLY",
};